export default __webpack_public_path__ + "static/media/covidMap.a3b382ca.JPG";